export default __webpack_public_path__ + "static/media/Left-Photo-Enterprise2x-mobile.5df87f94.jpg";